import {
  graphqlCall,
  setLockPin,
  SetLockPinMutation,
} from '@akin-home/amplify';
import { UpdateLockPINResponse } from '@akin-home/lock-screen';
import { shouldMockEndpoints } from '@akin-home/testing';

interface Params {
  /** ID of the user having their PIN set */
  user_id: string;

  /** The string value of the PIN */
  pin: string;
}

const callLockPinUpdate = ({ user_id, pin }: Params) =>
  graphqlCall<SetLockPinMutation>(setLockPin, {
    params: JSON.stringify({
      user_id,
      pin,
    }),
  });

const mockedCallLockPinUpdate = async (
  _: Params
): ReturnType<typeof callLockPinUpdate> => {
  return {
    data: {
      setLockPIN: JSON.stringify({
        success: true,
      }),
    },
  };
};

const mockableCallLockPinUpdate = shouldMockEndpoints()
  ? mockedCallLockPinUpdate
  : callLockPinUpdate;

export const updateLockPin = async (params: Params) => {
  try {
    const res = await mockableCallLockPinUpdate(params);

    if (res.errors?.length)
      return { success: false, error: res.errors[0].message };
    if (!res.data.setLockPIN) return { success: false, error: 'No Reponse' };

    return JSON.parse(res.data.setLockPIN) as UpdateLockPINResponse;
  } catch (ex) {
    return { success: false, error: ex };
  }
};
